import { useSets } from '@/hooks/useSets';

interface SetFilterProps {
  /** Currently selected Set ID, or null for "All Moves" */
  selectedSetId: string | null;
  /** Callback when the user selects a different Set */
  onSetChange: (setId: string | null) => void;
}

/**
 * Dropdown filter for selecting a Set to filter moves by.
 *
 * Shows "All Moves" as the default option, followed by all active Sets.
 * Moves without a set_id are displayed under "General" in the UI.
 */
export default function SetFilter({ selectedSetId, onSetChange }: SetFilterProps) {
  const { data, isLoading } = useSets('active');

  return (
    <select
      value={selectedSetId ?? ''}
      onChange={(e) => onSetChange(e.target.value || null)}
      className="rounded-lg border border-neutral-200 bg-primary-10 px-3 py-1.5 text-sm font-medium text-neutral-700 transition-colors hover:border-neutral-300 focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
      aria-label="Filter by Set"
    >
      <option value="">All Moves</option>
      {isLoading && (
        <option disabled>Loading...</option>
      )}
      {data?.sets.map((set) => (
        <option key={set.set_id} value={set.set_id}>
          {set.name}
        </option>
      ))}
    </select>
  );
}
